import { Avatar, ButtonBase, Chip, Paper, Stack, Typography } from "@mui/material";
import { Branch } from "@/types/branch";
import { stringToColor } from "@/utils/names";
import { formatPhone } from "@/utils/phones";
import { MENU_FLOWS, MENU_FLOW_LABELS } from "@/constants/global";

interface BranchCardProps {
  branch: Branch;
  onClick: (branch: Branch) => void;
  isActive: boolean;
  highlightService?: MENU_FLOWS;
}

const BranchCard = ({ branch, onClick, isActive, highlightService }: BranchCardProps) => {
  return (
    <ButtonBase
      onClick={() => onClick(branch)}
      sx={{
        borderRadius: 2,
        backgroundColor: isActive ? "grey.100" : "transparent",
        "&.MuiPaper-root": {
          backgroundColor: "white !important",
        },
      }}
      component={Paper}
    >
      <Stack direction="row" alignItems="center" flex={1} spacing={2} p={2}>
        <Avatar
          variant="rounded"
          sx={{
            width: 56,
            height: 56,
            bgcolor: stringToColor(branch.title),
          }}
        >
          {branch.title?.charAt(0)}
        </Avatar>

        <Stack alignItems="flex-start" spacing={0.5} flex={1}>
          <Stack
            direction="row"
            flex={1}
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
            width="100%"
          >
            <Typography variant="h4">{branch.title}</Typography>
            <Typography variant="body1" color="text.secondary">
              {formatPhone(branch.whatsapp, 505)}
            </Typography>
          </Stack>
          <Stack direction="row" spacing={1}>
            {branch.services?.map((service) => (
              <Chip
                key={service}
                size="small"
                variant={!highlightService || highlightService === service ? "filled" : "outlined"}
                color="primary"
                label={MENU_FLOW_LABELS[service as MENU_FLOWS]}
              />
            ))}
          </Stack>
        </Stack>
      </Stack>
    </ButtonBase>
  );
};

export default BranchCard;
